export function normalizeAmount(value: string | null): string | null {
  if (null === value) {
    return null;
  }

  const cleaned = value.replace(/\s/gu, "").replace(",", ".");

  return "" === cleaned ? null : cleaned;
}

export function parseAmount(value: string | null): number | null {
  const normalized = normalizeAmount(value);

  if (null === normalized) {
    return null;
  }

  const parsed = Number(normalized);

  return Number.isFinite(parsed) ? parsed : null;
}

export function formatAmount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    signDisplay: "exceptZero",
  }).format(value);
}
